import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import styled from 'styled-components';
import 'react-datepicker/dist/react-datepicker.css';
import { colorText, colorFieldsBorder } from '@/utils/palette';
import { ClockIcon } from '@/shared/dynamicImports';
import { DatePickerWrap } from './DatePickerElements';

const TimePickerField = React.memo(({ name, label = 'Select Time', defaultValue, onChange, error }) => {
  const [selectedTime, setSelectedTime] = useState(defaultValue ? new Date(`1970-01-01T${defaultValue}`) : null);
  const [timePickerOpen, setTimePickerOpen] = useState(false);

  const handleChange = (date) => {
    setSelectedTime(date);
    // Format the time as HH:mm
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    onChange(`${hours}:${minutes}`);
  };

  const handleClockIconClick = () => {
    setTimePickerOpen((prevState) => !prevState);
  };

  const handleTimePickerClick = () => {
    setTimePickerOpen(true);
  };

  return (
    <div>
      {label && <Label error={error}>{label}</Label>}
      <div style={{ display: 'flex' }}>
        <DatePickerWrap>
          <StyledDatePicker
            name={name}
            selected={selectedTime}
            onChange={handleChange}
            showTimeSelect
            showTimeSelectOnly
            timeIntervals={15}
            timeCaption='Time'
            dateFormat='h:mm aa'
            open={timePickerOpen}
            onClickOutside={() => setTimePickerOpen(false)}
            onClick={handleTimePickerClick}
            onFocus={handleTimePickerClick}
          />
        </DatePickerWrap>

        <StyledClockIcon onClick={handleClockIconClick} />
      </div>
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </div>
  );
});

TimePickerField.displayName = 'TimePickerField';

export default TimePickerField;

const Label = styled.div`
  font-size: 12px;
  margin-top: 5px;
  color: ${(props) => (props.error ? 'red' : colorText)};
`;

const ErrorMessage = styled.div`
  color: red;
  margin-bottom: 20px;
  font-size: 12px;
`;

const StyledClockIcon = styled(ClockIcon)`
  cursor: pointer;
  font-size: 16px;
  color: #6c757d;
  border: 1px solid ${colorFieldsBorder};
  border-radius: 2px;
  height: 32px;
  // padding: 2px;
  padding: 1px;
  width: 32px;
`;

const StyledDatePicker = styled(DatePicker)`
  outline: none;
  padding: 2px 12px;
  font-size: 16px;
  border: 1px solid ${colorFieldsBorder};
  border-radius: 2px;
  background-color: transparent !important;
  color: ${colorText};
  width: 100%;
`;
